var __merlinGlobal = (typeof window !== 'undefined' ? window : globalThis);
var __merlinTrustedTypes = __merlinGlobal.MerlinTrustedTypes || (__merlinGlobal.MerlinTrustedTypes = (function() {
    function safeSetInnerHTML(element, html) {
        if (!element) return;
        if (!html) {
            element.replaceChildren();
            return;
        }

        var doc = new DOMParser().parseFromString('<body>' + html + '</body>', 'text/html');
        element.replaceChildren();
        Array.from(doc.body.childNodes).forEach(function(node) {
            element.appendChild(document.adoptNode(node));
        });
    }

    function safeInsertAdjacentHTML(element, position, html) {
        if (!element || !html) return;

        var doc = new DOMParser().parseFromString('<body>' + html + '</body>', 'text/html');
        var fragment = document.createDocumentFragment();
        Array.from(doc.body.childNodes).forEach(function(node) {
            fragment.appendChild(document.adoptNode(node));
        });

        switch (position) {
            case 'beforeend':
                element.appendChild(fragment);
                break;
            case 'afterbegin':
                element.prepend(fragment);
                break;
            case 'beforebegin':
                element.before(fragment);
                break;
            case 'afterend':
                element.after(fragment);
                break;
        }
    }

    return {
        safeSetInnerHTML: safeSetInnerHTML,
        safeInsertAdjacentHTML: safeInsertAdjacentHTML
    };
})());
var safeSetInnerHTML = __merlinTrustedTypes.safeSetInnerHTML;
var safeInsertAdjacentHTML = __merlinTrustedTypes.safeInsertAdjacentHTML;
/**
 * Graph Explorer - Keyboard Module
 * Handles keyboard shortcuts and accessibility
 */

(function(global) {
    'use strict';

    let eventsBound = false;  // Prevent duplicate event binding on reinit

    // ============================================
    // Keyboard Shortcut Definitions
    // ============================================
    const shortcuts = {
        'r': { action: 'reset', description: 'Reset view' },
        'R': { action: 'reload', description: 'Reload data', shift: true },
        't': { action: 'theme', description: 'Toggle theme' },
        'l': { action: 'nodeLabels', description: 'Toggle node labels' },
        'e': { action: 'edgeLabels', description: 'Toggle edge labels' },
        'p': { action: 'physics', description: 'Toggle physics' },
        'i': { action: 'layout', description: 'Improve layout' },
        'f': { action: 'fit', description: 'Fit to screen' },
        '1': { action: 'singleSelect', description: 'Single select mode' },
        '2': { action: 'multiSelect', description: 'Multi select mode' },
        '/': { action: 'filterPanel', description: 'Find nodes' },
        'm': { action: 'aliasesPanel', description: 'Aliases' },
        'x': { action: 'extend', description: 'Extend selection' },
        'n': { action: 'connect', description: 'Connect nodes' },
        'g': { action: 'map', description: 'Map nodes' },
        's': { action: 'isolate', description: 'Isolate selection' },
        'q': { action: 'fqlWindow', description: 'FQL Editor' },
        'Delete': { action: 'remove', description: 'Remove selection' },
        'Tab': { action: 'contextPanel', description: 'Toggle context panel' },
        'Escape': { action: 'escape', description: 'Close panel / Deselect' }
    };

    // Ctrl/Cmd shortcuts
    const ctrlShortcuts = {
        'e': { action: 'export', description: 'Export graph' },
        's': { action: 'saveCheckpoint', description: 'Save checkpoint' },
        'a': { action: 'selectAll', description: 'Select all nodes' },
        'k': { action: 'explorerWindow', description: 'Open search & find' },
        'p': { action: 'checkpointsWindow', description: 'Open checkpoints' }
    };

    // ============================================
    // Initialization
    // ============================================
    function init() {
        bindKeyboardEvents();
        createHelpModal();
        
        console.log('[ExplorerKeyboard] Initialized');
    }

    // ============================================
    // Event Binding
    // ============================================
    function bindKeyboardEvents() {
        // Prevent duplicate event binding on reinit
        if (eventsBound) {
            return;
        }
        eventsBound = true;
        
        document.addEventListener('keydown', function(e) {
            // Skip if typing in input/textarea
            if (isInputFocused()) return;

            const key = e.key;
            const ctrl = e.ctrlKey || e.metaKey;
            const shift = e.shiftKey;

            // Handle Ctrl shortcuts
            if (ctrl && ctrlShortcuts[key.toLowerCase()]) {
                e.preventDefault();
                executeAction(ctrlShortcuts[key.toLowerCase()].action);
                return;
            }

            // Handle regular shortcuts
            const shortcut = shortcuts[key] || shortcuts[key.toLowerCase()];
            if (shortcut) {
                // Check if shift is required
                if (shortcut.shift && !shift) return;
                if (!shortcut.shift && shift && key !== key.toUpperCase()) return;

                e.preventDefault();
                executeAction(shortcut.action);
            }

            // Show help with ?
            if (key === '?' || (shift && key === '/')) {
                e.preventDefault();
                showHelp();
            }
        });
    }

    function isInputFocused() {
        const activeElement = document.activeElement;
        const tagName = activeElement?.tagName.toLowerCase();
        return tagName === 'input' || tagName === 'textarea' || tagName === 'select' ||
               activeElement?.isContentEditable;
    }

    // ============================================
    // Action Execution
    // ============================================
    function executeAction(action) {
        switch (action) {
            case 'reset':
                // Use ExplorerCursor.resetCursorView if available (new unified reset)
                if (typeof ExplorerCursor !== 'undefined' && ExplorerCursor.resetCursorView) {
                    console.log('[ExplorerKeyboard] Delegating reset to ExplorerCursor...');
                    ExplorerCursor.resetCursorView();
                    break;
                }
                // Fallback: Full cursor reset via ExplorerAPI
                if (typeof ExplorerAPI !== 'undefined' && ExplorerAPI.resetMeCursor) {
                    console.log('[ExplorerKeyboard] Resetting cursor and clearing graph...');
                    ExplorerAPI.resetMeCursor().then(function() {
                        console.log('[ExplorerKeyboard] Cursor reset successful');
                        // Clear the graph nodes and edges
                        if (typeof GraphExplorer !== 'undefined' && GraphExplorer.state) {
                            if (GraphExplorer.state.nodes) {
                                GraphExplorer.state.nodes.clear();
                            }
                            if (GraphExplorer.state.edges) {
                                GraphExplorer.state.edges.clear();
                            }
                            // Show empty state overlay (use showEmptyState directly since we know it's empty)
                            if (GraphExplorer.showEmptyState) {
                                GraphExplorer.showEmptyState();
                            }
                        }
                        // Also update aliases list to empty
                        if (ExplorerAPI.updateAliasesList) {
                            ExplorerAPI.updateAliasesList([]);
                        }
                        // Clear checkpoints and bookmarks
                        if (typeof ExplorerToolbar !== 'undefined') {
                            if (ExplorerToolbar.updateCheckpointsList) {
                                ExplorerToolbar.updateCheckpointsList([]);
                            }
                            if (ExplorerToolbar.updateBookmarksList) {
                                ExplorerToolbar.updateBookmarksList([]);
                            }
                        }
                        if (typeof ExplorerWindows !== 'undefined' && ExplorerWindows.clearCheckpointsAndBookmarks) {
                            ExplorerWindows.clearCheckpointsAndBookmarks();
                        }
                        // Refresh FQL history panel (should now be empty)
                        if (typeof ExplorerWindows !== 'undefined' && ExplorerWindows.loadFqlHistory) {
                            ExplorerWindows.loadFqlHistory();
                        }
                        console.log('[ExplorerKeyboard] Graph cleared, checkpoints and bookmarks cleared');
                    }).catch(function(err) {
                        console.error('[ExplorerKeyboard] Reset failed:', err);
                    });
                } else if (typeof resetToCheckpoint === 'function') {
                    resetToCheckpoint();
                }
                break;
            case 'reload':
                if (typeof reloadGraph === 'function') reloadGraph();
                break;
            case 'theme':
                if (typeof GraphExplorer !== 'undefined' && GraphExplorer.toggleTheme) {
                    GraphExplorer.toggleTheme();
                    if (typeof ExplorerToolbar !== 'undefined' && ExplorerToolbar.setButtonActive) {
                        ExplorerToolbar.setButtonActive('btn-theme', GraphExplorer.getTheme() === 'light');
                    }
                }
                break;
            case 'nodeLabels':
                if (typeof GraphExplorer !== 'undefined' && GraphExplorer.toggleNodeLabels) {
                    const nlVisible = GraphExplorer.toggleNodeLabels();
                    if (typeof ExplorerToolbar !== 'undefined' && ExplorerToolbar.setButtonActive) {
                        ExplorerToolbar.setButtonActive('btn-node-labels', nlVisible);
                    }
                }
                break;
            case 'edgeLabels':
                if (typeof GraphExplorer !== 'undefined' && GraphExplorer.toggleEdgeLabels) {
                    const elVisible = GraphExplorer.toggleEdgeLabels();
                    if (typeof ExplorerToolbar !== 'undefined' && ExplorerToolbar.setButtonActive) {
                        ExplorerToolbar.setButtonActive('btn-edge-labels', elVisible);
                    }
                }
                break;
            case 'physics':
                if (typeof GraphExplorer !== 'undefined' && GraphExplorer.togglePhysics) {
                    const physicsOn = GraphExplorer.togglePhysics();
                    if (typeof ExplorerToolbar !== 'undefined' && ExplorerToolbar.setButtonActive) {
                        ExplorerToolbar.setButtonActive('btn-physics', physicsOn);
                    }
                }
                break;
            case 'layout':
                if (typeof GraphExplorer !== 'undefined' && GraphExplorer.improveLayout) {
                    GraphExplorer.improveLayout();
                }
                break;
            case 'fit':
                if (typeof GraphExplorer !== 'undefined' && GraphExplorer.fitToScreen) {
                    GraphExplorer.fitToScreen();
                }
                break;
            case 'singleSelect':
                if (typeof GraphExplorer !== 'undefined' && GraphExplorer.setSelectionMode) {
                    GraphExplorer.setSelectionMode('single');
                    if (typeof ExplorerToolbar !== 'undefined' && ExplorerToolbar.setButtonActive) {
                        ExplorerToolbar.setButtonActive('btn-single', true);
                        ExplorerToolbar.setButtonActive('btn-multi', false);
                    }
                }
                break;
            case 'multiSelect':
                if (typeof GraphExplorer !== 'undefined' && GraphExplorer.setSelectionMode) {
                    GraphExplorer.setSelectionMode('multi');
                    if (typeof ExplorerToolbar !== 'undefined' && ExplorerToolbar.setButtonActive) {
                        ExplorerToolbar.setButtonActive('btn-single', false);
                        ExplorerToolbar.setButtonActive('btn-multi', true);
                    }
                }
                break;
            case 'isolate':
                if (typeof isolateSelection === 'function') isolateSelection();
                break;
            case 'remove':
                if (typeof removeSelection === 'function') removeSelection();
                break;
            case 'filterPanel':
                ExplorerPanels.open('filter');
                break;
            case 'toggleHubs':
                if (typeof toggleInfluentialNodes === 'function') toggleInfluentialNodes();
                break;
            case 'algorithmPanel':
                ExplorerPanels.open('algorithm');
                break;
            case 'aliasesPanel':
                ExplorerPanels.open('aliases');
                break;
            case 'explorerWindow':
                if (typeof ExplorerWindows !== 'undefined' && ExplorerWindows.toggle) {
                    ExplorerWindows.toggle('explorer');
                }
                break;
            case 'searchWindow':
                // Legacy: redirect to explorer window
                if (typeof ExplorerWindows !== 'undefined' && ExplorerWindows.toggle) {
                    ExplorerWindows.toggle('explorer');
                }
                break;
            case 'checkpointsWindow':
                if (typeof ExplorerWindows !== 'undefined' && ExplorerWindows.toggle) {
                    ExplorerWindows.toggle('checkpoints');
                }
                break;
            case 'fqlWindow':
                if (typeof ExplorerWindows !== 'undefined' && ExplorerWindows.toggle) {
                    ExplorerWindows.toggle('fql');
                }
                break;
            case 'export':
                ExplorerPanels.open('export');
                break;
            case 'extend':
                ExplorerPanels.nodeAction('extend');
                break;
            case 'connect':
                ExplorerPanels.nodeAction('connect');
                break;
            case 'map':
                ExplorerPanels.nodeAction('map');
                break;
            case 'contextPanel':
                ExplorerPanels.toggleContext();
                break;
            case 'saveCheckpoint':
                ExplorerPanels.saveCheckpoint();
                break;
            case 'loadCheckpoint':
                ExplorerPanels.loadCheckpoint();
                break;
            case 'selectAll':
                selectAllNodes();
                break;
            case 'escape':
                if (ExplorerPanels.isOpen()) {
                    ExplorerPanels.close();
                } else if (ExplorerPanels.isContextOpen && ExplorerPanels.isContextOpen()) {
                    ExplorerPanels.closeContext();
                } else if (typeof ExplorerWindows !== 'undefined' && ExplorerWindows.hasOpenWindows && ExplorerWindows.hasOpenWindows()) {
                    ExplorerWindows.closeAll();
                } else {
                    // No panels open - close the modal (send message to parent)
                    if (window.parent !== window) {
                        window.parent.postMessage({ type: 'close_graph_modal' }, '*');
                    }
                    deselectAll();
                }
                break;
        }
    }

    // ============================================
    // Selection Helpers
    // ============================================
    function selectAllNodes() {
        if (typeof network !== 'undefined' && typeof nodes !== 'undefined') {
            const allNodeIds = nodes.getIds();
            network.selectNodes(allNodeIds);
            ExplorerUtils.announceChange(`Selected ${allNodeIds.length} nodes`);
        }
    }

    function deselectAll() {
        if (typeof network !== 'undefined') {
            network.unselectAll();
            ExplorerUtils.announceChange('Selection cleared');
        }
    }

    // ============================================
    // Help Modal
    // ============================================
    function createHelpModal() {
        // Will be created on demand
    }

    function showHelp() {
        let modal = document.getElementById('keyboard-help-modal');
        
        if (!modal) {
            modal = document.createElement('div');
            modal.id = 'keyboard-help-modal';
            modal.className = 'overlay-backdrop visible';
            modal.style.cssText = 'display: flex; align-items: center; justify-content: center;';
            
            const content = document.createElement('div');
            content.style.cssText = `
                background: var(--explorer-surface);
                border-radius: var(--border-radius);
                padding: 20px;
                max-width: 400px;
                max-height: 80vh;
                overflow-y: auto;
                color: var(--explorer-text);
            `;
            
            safeSetInnerHTML(content, `
                <h3 style="margin: 0 0 16px; font-size: 16px;">Keyboard Shortcuts</h3>
                <table style="width: 100%; font-size: 12px; border-collapse: collapse;">
                    ${Object.entries(shortcuts).map(([key, data]) => `
                        <tr style="border-bottom: 1px solid var(--explorer-border);">
                            <td style="padding: 6px 8px 6px 0;"><kbd style="background: rgba(255,255,255,0.1); padding: 2px 6px; border-radius: 3px; font-family: monospace;">${data.shift ? 'Shift+' : ''}${key}</kbd></td>
                            <td style="padding: 6px 0;">${data.description}</td>
                        </tr>
                    `).join('')}
                    <tr><td colspan="2" style="padding: 12px 0 6px; font-weight: bold;">With Ctrl/Cmd:</td></tr>
                    ${Object.entries(ctrlShortcuts).map(([key, data]) => `
                        <tr style="border-bottom: 1px solid var(--explorer-border);">
                            <td style="padding: 6px 8px 6px 0;"><kbd style="background: rgba(255,255,255,0.1); padding: 2px 6px; border-radius: 3px; font-family: monospace;">Ctrl+${key.toUpperCase()}</kbd></td>
                            <td style="padding: 6px 0;">${data.description}</td>
                        </tr>
                    `).join('')}
                </table>
                <p style="margin: 16px 0 0; font-size: 11px; opacity: 0.6;">Press Escape or click outside to close</p>
            `);
            
            modal.appendChild(content);
            document.querySelector('.graph-explorer')?.appendChild(modal);
            
            modal.addEventListener('click', function(e) {
                if (e.target === modal) {
                    hideHelp();
                }
            });
        } else {
            modal.style.display = 'flex';
            modal.classList.add('visible');
        }

        ExplorerUtils.announceChange('Keyboard shortcuts help opened');
    }

    function hideHelp() {
        const modal = document.getElementById('keyboard-help-modal');
        if (modal) {
            modal.style.display = 'none';
            modal.classList.remove('visible');
        }
    }

    // ============================================
    // Public API
    // ============================================
    global.ExplorerKeyboard = {
        init,
        executeAction,
        showHelp,
        hideHelp
    };

})(window);
